export function listUserLibraries<T extends { name?: string | null; createdAt: string }>(
  libraries: T[],
  { search }: { search: string },
): T[] {
  const query = search.trim().toLowerCase();
  const filtered = query
    ? libraries.filter((library) => (library.name || '').toLowerCase().includes(query))
    : libraries;

  return [...filtered].sort((left, right) => {
    const leftTime = Date.parse(left.createdAt) || 0;
    const rightTime = Date.parse(right.createdAt) || 0;
    return rightTime - leftTime;
  });
}
